import "@babel/polyfill";
import "whatwg-fetch";
import "intersection-observer";
import smoothscroll from "smoothscroll-polyfill";
import "objectFitPolyfill";

smoothscroll.polyfill();
objectFitPolyfill();

import "~/styles/main.scss";

import bootstrap from "./bootstrap";

bootstrap();



// WEBPACK FOOTER //
// ./public/assets/scripts/main.js